import type { PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

/** Wrapped, so a missing provider (null) differs from no URL (undefined). */
const CabinetUrlContext = createContext<{ url: string | undefined } | null>(
  null,
)

/** cabinet's URL (`VITE_ADMIN_CABINET_URL`), for opening test seeds. */
export function CabinetUrlProvider({
  url,
  children,
}: PropsWithChildren<{ url: string | undefined }>) {
  return <CabinetUrlContext value={{ url }}>{children}</CabinetUrlContext>
}

/** cabinet's URL without a trailing slash, or undefined when none is set. */
export function useCabinetUrl(): string | undefined {
  const value = useContext(CabinetUrlContext)
  if (value === null) {
    throw new Error('useCabinetUrl() outside <CabinetUrlProvider>')
  }
  return value.url
}
